import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/email")({
	component: EmailLayout,
});

function EmailLayout() {
	return <Outlet />;
}
